import { GroupAttributionCveSidePanelWebComponent } from './component/GroupAttributionCveSidePanelWebComponent';

export { GroupAttributionCveSidePanelWebComponent };
